import { createAction } from 'redux-actions';
import { openMobileOverlay } from 'shared/utils/open-overlay';


export const VISIT_CHANNEL = 'CLIENT.VISIT-CHANNEL';
const VISIT_CHANNEL_ACTION = createAction(VISIT_CHANNEL);

export const OPEN_VIDEO_PAGE = 'CLIENT.OPEN.VIDEO-PAGE';
const OPEN_VIDEO_PAGE_ACTION = createAction(OPEN_VIDEO_PAGE);


export function visitChannel() {
  return function (dispatch) {
    dispatch(VISIT_CHANNEL_ACTION());

    return openMobileOverlay();
  };
}

export function openVideoPage(videoId) {
  return function (dispatch) {
    dispatch(OPEN_VIDEO_PAGE_ACTION());

    return openMobileOverlay(`#/video/${videoId}`);
  };
}



// WEBPACK FOOTER //
// ./src/widget/redux/client/actions/mobile-overlay-openners/main-openners.js